export default function getQueryString (field, url) {

    var href = url ? url : (typeof window!== "undefined" ? window.location.href : '');
    var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string ? string[1] : null;
  };
  